<template>
  <!--
    Embedded Grafana panel, fully interactive (hover tooltips, legend, zoom).
    A small button in the top-right corner opens the full dashboard in a new tab.
  -->
  <div class="grafana-frame">
    <iframe
      class="grafana-frame__iframe"
      :src="src"
      :title="title"
      loading="lazy"
      frameborder="0"
    ></iframe>
    <a
      class="grafana-frame__open"
      :href="href"
      target="_blank"
      rel="noopener"
      :title="hint || 'Grafana'"
    >
      <v-icon size="14">mdi-open-in-new</v-icon>
      <span class="grafana-frame__open-label">Grafana</span>
    </a>
  </div>
</template>

<script>
export default {
  name: "GrafanaFrame",
  props: {
    src: { type: String, required: true }, // d-solo panel url
    href: { type: String, required: true }, // full dashboard url opened by the corner button
    title: { type: String, default: "Grafana" },
    hint: { type: String, default: "" }
  }
};
</script>

<style scoped>
.grafana-frame {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
  background: #fafbfc;
}
.grafana-frame__iframe {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
}
/* Corner button: discreet until the panel is hovered, never in the way of the chart */
.grafana-frame__open {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 26px;
  padding: 0 9px;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  color: rgb(var(--v-theme-primary));
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(0, 147, 191, 0.35);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
  text-decoration: none;
  opacity: 0.55;
  transition: opacity 0.15s ease, background 0.15s ease, color 0.15s ease, transform 0.15s ease;
}
.grafana-frame:hover .grafana-frame__open {
  opacity: 1;
}
.grafana-frame__open:hover {
  background: rgb(var(--v-theme-primary));
  color: #fff;
  border-color: rgb(var(--v-theme-primary));
  transform: translateY(-1px);
}
.grafana-frame__open:focus-visible {
  opacity: 1;
  outline: 2px solid rgb(var(--v-theme-primary));
  outline-offset: 2px;
}
@media (max-width: 600px) {
  .grafana-frame__open-label {
    display: none;
  }
  .grafana-frame__open {
    padding: 0 6px;
    opacity: 0.85;
  }
}
</style>
